// Preserve server-provided user-facing errors; callers supply localized fallbacks.
export const getErrorMessage = (error, fallback) => error?.response?.data?.message || fallback;

// Translate account errors without exposing English-only server messages.
export const getAccountErrorMessage = (error, t, fallbackKey) => {
    const keys = {
        E_AUTH_0002: 'invalidVerificationCode', E_AUTH_0003: 'verificationCodeExpired',
        E_AUTH_0007: 'passwordRequirements', E_AUTH_0014: 'passwordMismatch',
        E_AUTH_0005: 'usernameAlreadyTaken', E_AUTH_0015: 'invalidUsername',
        E_AUTH_0016: 'currentPasswordIncorrect', E_AUTH_0022: 'tooManyAttempts',
        E_AUTH_0024: 'passwordSetupUnavailable',
    };
    const key = keys[error?.response?.data?.messageId];
    return t(key ? `auth.errors.${key}` : fallbackKey);
};
